import { useCallback, useEffect, useState } from "react";
import IFilterAppointment from "../filterAppointment.interface";
import { IAppointmentPage } from "../appointment.interface";
import appointmentService from "../appointmentService";
import { AxiosResponse } from "axios";

const useGetMyAppointment = (filters: IFilterAppointment, enabled = true) => {
  const [data, setData] = useState<IAppointmentPage>();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>("");

  const callApi = useCallback(() => {
    return appointmentService.getMyAppointments(filters);
  }, [filters]);

  const transformResponse = useCallback((response: AxiosResponse<IAppointmentPage>) => {
    if (response) {
      setData(response.data);
    }
  }, []);

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const response = await callApi();
      transformResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    (async () => {
      try {
        setLoading(true);
        const response = await callApi();
        transformResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [enabled]);

  return { data, error, isLoading, refetch };
};

export default useGetMyAppointment;
